import StateRecord from '../records/session-state';
import {
  RESET_SESSION,
  SET_SESSION,
} from '../actions/session-actions.ts';

const initialState = new StateRecord();

export default (state = initialState,
                action) => {
  switch (action.type) {
    case SET_SESSION:
      return state
        .set('account', action.session.account)
        .set('authenticatedPatientId', action.session.id)
        .set('commonProducts', action.session.commonProducts)
        .set('groups', action.session.groups);

    case RESET_SESSION:
      return initialState;

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./main/reducers/session-reducer.js